import { render, staticRenderFns } from "./SystemMessage.vue?vue&type=template&id=35638ccc&scoped=true"
import script from "./SystemMessage.vue?vue&type=script&lang=js"
export * from "./SystemMessage.vue?vue&type=script&lang=js"
import style0 from "./SystemMessage.vue?vue&type=style&index=0&id=35638ccc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35638ccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35638ccc')) {
      api.createRecord('35638ccc', component.options)
    } else {
      api.reload('35638ccc', component.options)
    }
    module.hot.accept("./SystemMessage.vue?vue&type=template&id=35638ccc&scoped=true", function () {
      api.rerender('35638ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/SystemMessage.vue"
export default component.exports